import { Menu, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { MdMoreVert } from "react-icons/md";
import { Link } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ListAction = ({
  onViewClick,
  onDeleteClick,
  isUserDashboard,
  showDeleteButton,
  onEditClick
}) => {
  return (
    <>
      <Menu as="div" className="relative">
        <div>
          <Menu.Button
            className={"relative flex rounded-md p-2 bg-white text-lg"}
          >
            <span />
            <MdMoreVert />
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white py-1 shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none">
            {isUserDashboard ? (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to=""
                    className={classNames(
                      active ? "bg-gray-100" : "",
                      "flex px-4 py-2 text-sm text-gray-700 gap-4 items-center"
                    )}
                    onClick={onEditClick}
                  >
                    Edit
                  </Link>
                )}
              </Menu.Item>
            ) : (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to=""
                    className={classNames(
                      active ? "bg-gray-100" : "",
                      "flex px-4 py-2 text-sm text-gray-700 gap-4 items-center"
                    )}
                    onClick={onViewClick}
                  >
                    View
                  </Link>
                )}
              </Menu.Item>
            )}
            {showDeleteButton && (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to=""
                    className={classNames(
                      active ? "bg-gray-100" : "",
                      "flex px-4 py-2 text-sm text-gray-700  gap-4 items-center"
                    )}
                    onClick={onDeleteClick}
                  >
                    Delete
                  </Link>
                )}
              </Menu.Item>
            )}
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  );
};

export default ListAction;
